import { useState } from "react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Dialog, DialogContent, DialogTitle, DialogDescription, DialogHeader, DialogFooter } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";

export default function CreateWorkspaceDialog({ open, onOpenChange, onCreated }) {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    setBusy(true);
    try {
      const { data } = await api.post("/workspaces", { name: name.trim(), description });
      toast.success("Workspace created");
      onCreated?.();
      setName(""); setDescription("");
      onOpenChange(false);
      navigate(`/workspace/${data.id}`);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Failed");
    } finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="rounded-none border-[#0D0D0D] max-w-md" data-testid="create-workspace-dialog">
        <DialogHeader>
          <div className="font-mono text-xs uppercase tracking-[0.3em] text-[#5C5C5C]">/ new workspace</div>
          <DialogTitle className="font-heading font-black tracking-tight text-3xl">Spin it up.</DialogTitle>
          <DialogDescription className="sr-only">Create a new team workspace</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label className="text-xs uppercase tracking-[0.2em] font-bold">Name</Label>
            <Input value={name} onChange={(e) => setName(e.target.value)} required autoFocus
              className="mt-2 rounded-none border-[#0D0D0D] h-11" data-testid="new-workspace-name" />
          </div>
          <div>
            <Label className="text-xs uppercase tracking-[0.2em] font-bold">Description</Label>
            <Textarea value={description} onChange={(e) => setDescription(e.target.value)} rows={3}
              className="mt-2 rounded-none border-[#0D0D0D]" data-testid="new-workspace-description" />
          </div>
          <DialogFooter className="gap-2 pt-2">
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)} className="rounded-none border-[#0D0D0D]" data-testid="new-workspace-cancel">Cancel</Button>
            <Button type="submit" disabled={busy} className="rounded-none bg-[#FF3B30] hover:bg-[#0D0D0D] text-white" data-testid="new-workspace-submit">
              {busy ? "Creating…" : "Create →"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
